import { useSider } from '../components/AppLayout';

/**
 * 计算固定底部栏的样式，自动适应侧边栏宽度
 * @param {Object} extraStyles - 额外的样式覆盖
 * @returns {Object} 固定底部栏的样式对象
 */
export const useFixedFooter = (extraStyles = {}) => {
  const { siderWidth } = useSider();
  
  const defaultStyles = {
    position: 'fixed',
    bottom: 0,
    left: `${siderWidth + 16}px`,
    right: 0,
    padding: '16px 24px',
    background: '#fff',
    textAlign: 'center',
    borderTop: '1px solid #e8e8e8',
    zIndex: 1000,
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)'
  };

  return {
    ...defaultStyles,
    ...extraStyles
  };
};

/**
 * 获取固定底部栏的占位空间高度
 * @param {number} height - 自定义高度，默认80px
 * @returns {Object} 占位空间的样式对象
 */
export const useFixedFooterPlaceholder = (height = 80) => {
  return {
    height: `${height}px`
  };
}; 